import { makeStyles } from '@mui/styles';

const drawerWidth = 200;

export const useStyles = makeStyles((Paper) => ({
  permanentDrawer: {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      height: '82%',
      marginLeft: '2%',
      borderRadius: 20,
      overflowY: 'auto',
      overflowX: 'hidden',
    },
  },
}));
